// delete this file when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled

export const SET_TWP_BENEFITS_MODAL_OPEN =
	'state.ui.twp-benefits-modal.SET_TWP_BENEFITS_MODAL_OPEN' as const;

export type ShowTwpBenefitsModalAction = {
	type: typeof SET_TWP_BENEFITS_MODAL_OPEN;
	payload: boolean;
};

export type State = {
	isTwpBenefitsModalOpen: boolean;
};
